import { IUploadFile } from '@/graphql/__generated__/global/types';

export const getAspectRatio = (img?: IUploadFile) => {
    const { height, width } = img || {};
    if (!height || !width) {
        return 1;
    }

    return width / height;
};
